import React from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { type useCreditCardOptions } from '../../../../hooks';
import {
  type GiftCardCheckoutFormFieldRules,
  type GiftCardCheckoutFormReturn,
} from '../../form';
import { GiftCardCheckoutFormV1 } from './GiftCardCheckoutFormV1';
import { GiftCardCheckoutFormV2 } from './GiftCardCheckoutFormV2';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardCheckoutForm = (props: GiftCardCheckoutFormProps) => {
  const isStripeSdkEnabled = useFeatureFlag('CELS-4676-gift-card-stripe-sdk-enabled'); // prettier-ignore

  if (isStripeSdkEnabled) {
    return <GiftCardCheckoutFormV2 {...props} />;
  }

  return <GiftCardCheckoutFormV1 {...props} />;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardCheckoutFormProps = {
  purchaseAttempt: number;
  form: GiftCardCheckoutFormReturn;
  rules: GiftCardCheckoutFormFieldRules;
  paymentMethods: ReturnType<typeof useCreditCardOptions>['creditCardOptions'];
  submitForm: () => Promise<void>;
  sectionTitles?: {
    amount: string;
    details: string;
    deliveryDate: string;
    deliveryMethod: string;
    recipientEmail: string;
    paymentMethod: string;
  };
};
